// round number to given decimal places with "half-up" mode, negative midpoints
// away from zero like the backend's BigDecimal RoundingMode.HALF_UP
// (https://www.htmlgoodies.com/javascript/round-in-javascript/)
const roundHalfUp = (value: string | number, decimals: number = 2): number => {
  const number = Number.parseFloat(value + "e" + decimals);
  const rounded = Math.sign(number) * Math.round(Math.abs(number));
  return Number(rounded + "e-" + decimals);
};

export default roundHalfUp;
